import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { trim } from 'ramda';

import withFormItem from './withFormItem';
import withFormikField, { formFieldPropTypes } from './withFormikField';
import { PHONE_TEXT_MASK } from 'constants/regexp';

const defaultPhoneMask = PHONE_TEXT_MASK;

@withFormItem
export class InputComponent extends Component {
    static propTypes = {
        ...formFieldPropTypes,
        placeholder: PropTypes.string,
        mask: PropTypes.oneOfType([
            PropTypes.array,
            PropTypes.func
        ])
    };

    onChange = e => {
        this.props.onChange(e.target.value || '');
    }

    onBlur = () => this.props.onChange(trim(this.props.value || ''));

    render() {
        const { value, placeholder, mask } = this.props;

        return (
            <MaskedInput
                mask={mask || defaultPhoneMask}
                type="text"
                className="ant-input"
                value={value}
                placeholderChar={'\u2000'}
                placeholder={placeholder}
                onChange={this.onChange}
                onBlur={this.onBlur} />
        );
    }
}

export default withFormikField(InputComponent);
